<template>
  <v-container fluid>
    <h1 class="text-h3 mb-4">Тест Route Guards</h1>
    
    <v-alert type="info" class="mb-4">
      <div class="text-h6 mb-2">Текущий пользователь:</div>
      <div><strong>Роли:</strong> {{ userRoles.join(', ') || 'Нет ролей' }}</div>
      <div><strong>Администратор:</strong> 
        <v-chip :color="isAdmin ? 'success' : 'default'" size="small" class="ml-2">
          {{ isAdmin ? 'Да' : 'Нет' }}
        </v-chip>
      </div>
    </v-alert>
    
    <v-row class="mt-4">
      <v-col cols="12" md="6">
        <v-card>
          <v-card-title>Публичные маршруты</v-card-title>
          <v-list>
            <v-list-item
              v-for="route in publicRoutes"
              :key="route.path"
              :to="route.path"
            >
              <v-list-item-title>{{ route.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      
      <v-col cols="12" md="6">
        <v-card>
          <v-card-title>Защищённые маршруты</v-card-title>
          <v-list>
            <v-list-item
              v-for="route in protectedRoutes"
              :key="route.path"
              :to="route.path"
            >
              <v-list-item-title>
                {{ route.title }}
                <v-chip v-if="route.requiresRoles" size="x-small" color="warning" class="float-end">
                  {{ route.requiresRoles.join(', ') }}
                </v-chip>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
    
    <v-row class="mt-4">
      <v-col cols="12">
        <v-card>
          <v-card-title>Админские маршруты</v-card-title>
          <v-list>
            <v-list-item
              v-for="route in adminRoutes"
              :key="route.path"
              :to="route.path"
              :disabled="!isAdmin"
            >
              <v-list-item-title>
                {{ route.title }}
                <v-chip size="x-small" color="error" class="float-end">admin</v-chip>
              </v-list-item-title>
            </v-list-item>
          </v-list>
          <v-card-text v-if="!isAdmin" class="text-grey">
            * Эти маршруты доступны только администраторам
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    
    <v-card class="mt-4">
      <v-card-title>Проверка доступа</v-card-title>
      <v-card-text>
        <v-btn color="warning" @click="tryAccessAdminRoute">
          Попробовать открыть админскую страницу
        </v-btn>
        <v-alert
          v-if="accessMessage"
          :type="messageClass === 'text-success' ? 'success' : 'error'"
          class="mt-3"
        >
          {{ accessMessage }}
        </v-alert>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'TestRouteGuards',
  data() {
    return {
      accessMessage: '',
      messageClass: '',
      publicRoutes: [
        { path: '/', title: 'Главная' },
        { path: '/signin', title: 'Вход' },
        { path: '/signup', title: 'Регистрация' },
        { path: '/health', title: 'Health Check' }
      ],
      protectedRoutes: [
        { path: '/dashboard', title: 'Панель управления' },
        { path: '/projects', title: 'Проекты' },
        { path: '/results', title: 'Результаты' },
        { path: '/telegram', title: 'Телеграм' }
      ],
      adminRoutes: [
        { path: '/admin/users', title: 'Управление пользователями', requiresRoles: ['admin'] },
        { path: '/admin/monitoring', title: 'Мониторинг системы', requiresRoles: ['admin'] },
        { path: '/admin/sources', title: 'Настройка источников', requiresRoles: ['admin'] },
        { path: '/admin/invitations', title: 'Коды приглашений', requiresRoles: ['admin'] }
      ]
    };
  },
  computed: {
    ...mapGetters(['userRoles', 'isAdmin'])
  },
  methods: {
    async tryAccessAdminRoute() {
      try {
        await this.$router.push('/admin/users');
        this.accessMessage = 'Успешно! Вы перешли на админскую страницу.';
        this.messageClass = 'text-success';
      } catch (error) {
        this.accessMessage = 'Доступ запрещён. Вы были перенаправлены.';
        this.messageClass = 'text-danger';
      }
    }
  }
};
</script>

<style scoped>
/* Vuetify handles most styling */
</style>